export default class ModalVideo {
  constructor() {
    this._init.apply( this, arguments )
    console.log('modal')
  }

  _init( elements ) {
    this.setting = this._arrayMerge( elements )
    this.DOM = {}
    this.DOM.body       = document.body
    this.DOM.modal      = document.getElementById( this.setting.modal )
    if ( this.DOM.modal === null ) { return  }

    this.DOM.overlay       = this.DOM.modal.querySelector( '.l-modal_overlay' )
    this.DOM.container     = this.DOM.modal.querySelector( this.setting.targetModal )
    this.DOM.closeButton   = this.DOM.modal.querySelectorAll( this.setting.closeButton )
    this.DOM.triggerButton = document.querySelectorAll( this.setting.triggerButton )
    this.pageScroll        = null
    
    this.eventType = this._getEventType()
    this._handleEvent()
  }

  _getEventType() {
    return window.ontouchstart ? 'touchstart' : 'click'
  }

  _arrayMerge() {
    let result = false

    if (arguments && typeof arguments === 'object') {
      result = {}
      ;[].forEach.call(arguments, (elem, i, array) => {
        for (let key in elem) {
          result[key] = elem[key]
        }
      })
    }
    return result
  }

  _handleEvent() {
    ;[].forEach.call( this.DOM.triggerButton, ( button, i ) => {
      button.addEventListener( this.eventType, e => {
        e.preventDefault()
        let href = e.currentTarget.getAttribute( 'href' )
        let video = `<div class="l-modal_youtube"><iframe width="560" height="315" src="${href}" frameborder="0" allowfullscreen></iframe></div>`

        this._show()
        this._keyEvent()
        this.DOM.container.innerHTML = video
      })
    })

    this.DOM.overlay.addEventListener( this.eventType, e => {
      e.preventDefault()
      this._hide()
    })

    ;[].forEach.call(this.DOM.closeButton, ( closeButton, i ) => {
      closeButton.addEventListener( this.eventType, e => {
        e.preventDefault()
        this._hide()
      })
    })
  }
  
  _show() {
    // モーダルが開いたら、bodyにfixedを付与
    this.pageScroll = window.scrollY
    this.DOM.body.style.position = 'fixed';
    this.DOM.body.style.top   = `-${this.pageScroll}px`;
    this.DOM.body.style.left  = '0'
    this.DOM.body.style.right = '0'

    this.DOM.modal.classList.add( 'modal-show' )
  }

  _hide() {
    // モーダルが閉じられた時の処理
    this.DOM.body.style.position = '';
    this.DOM.body.style.top   = '';
    this.DOM.body.style.left  = '';
    this.DOM.body.style.right = '';
    window.scrollTo(0, this.pageScroll);

    this.DOM.modal.classList.remove( 'modal-show' )
    this.DOM.container.innerHTML = ''
  }

  _keyEvent() {
    document.addEventListener( 'keydown', e => {
      let key = e.keyCode
      if ( key === 27 ) {
        this._hide()
      }
    })
  }
}

new ModalVideo({
	modal        : 'js-modal-movie',
  targetModal  : '.js-modal-movie-container',
	closeButton  : '#js-close-btn',
	triggerButton: '.js-modal-movie-trigger',
	triggerOption: false  
})
